const pkg = state => state.pkg
const app = state => state.app
const device = state => state.app.device
const sidebar = state => state.app.sidebar
const effect = state => state.app.effect
const menuitems = state => state.menu.items
const componententry = state => state.menu.items.filter(({ meta }) => meta?.label === 'Components')[0]

export {
  pkg,
  app,
  device,
  sidebar,
  effect,
  menuitems,
  componententry
}
